import {
  Map, TileLayer } from "src/domains/shared/react-openlayers";
import { configObject } from "src/awsconfig";
import {
  DATA_BUCKET_NAME,
  S3_API_URL,
} from "src/domains/shared/constants/constants";

import { TileMatrix } from "src/domains/shared/api/gisLayer/gisLayer.model";
import { OrthoMode } from "src/domains/timeseries/TimeSeriesPage.model";
import { ERROR_TILE_URL } from "./layerCreators";

type ValidOrthoMode = Exclude<OrthoMode, null>;

interface BaseTileLayerProps {
  orthoMode: OrthoMode;
  timeSeriesId: number;
  tileMatrix: TileMatrix;
  minZoom: number;
  maxZoom: number;
}

const BASE_Z_INDEX = 1;

const TILE_PATH_MAP: Record<ValidOrthoMode, string> = {
  mosaic: "orthomosaic_tiles",
  dsm: "colorized_dem_tiles",
};

export const BaseTileLayer = ({
  orthoMode,
  timeSeriesId,
  tileMatrix,
  minZoom,
  maxZoom,
}: BaseTileLayerProps) => {
  if (!orthoMode || orthoMode === null) return null;

  const tilePath = TILE_PATH_MAP[orthoMode];

  return (
    <Map.TileLayer
      tileMatrix={tileMatrix}
      zIndex={BASE_Z_INDEX}
      errorTileUrl={ERROR_TILE_URL}
      url={`${configObject[S3_API_URL]}${configObject[DATA_BUCKET_NAME]}/public/${timeSeriesId}/manifold/${tilePath}/{z}/{x}/{y}.png`}
      minZoom={minZoom}
      maxZoom={maxZoom}
    />
  );
};
